import React from "react";

function TechStackCard({ category, clientValue, technologies }) {
  return (
    <div className="tech-stack-card">
      <h3>{category}</h3>
      <p className="tech-stack-value">{clientValue}</p>
      <div className="tech-stack-pills">
        {technologies.map((tech, index) => (
          <span key={index} className="about-tool-pill">
            {tech}
          </span>
        ))}
      </div>
    </div>
  );
}

export default TechStackCard;
